module.exports = __webpack_public_path__ + "img/envelope.8bbac02a.svg";